import { useNavigate } from "react-router-dom";
import { SearchableSelect, type SearchableSelectOption } from "./SearchableSelect";
import { cn } from "@/lib/utils";

interface AdminDashboardQuickNavProps {
  propertyOptions: SearchableSelectOption[];
  workerOptions: SearchableSelectOption[];
  propertyValue: string;
  workerValue: string;
  onPropertyChange: (value: string) => void;
  onWorkerChange: (value: string) => void;
  className?: string;
}

export function AdminDashboardQuickNav({
  propertyOptions,
  workerOptions,
  propertyValue,
  workerValue,
  onPropertyChange,
  onWorkerChange,
  className,
}: AdminDashboardQuickNavProps) {
  const navigate = useNavigate();

  // CRITICAL: Nawigacja bezwarunkowa i synchroniczna – bez await, bez zależności od stanu rodzica.
  // navigate() wywołane najpierw, żeby uniknąć batchowania re-renderu i "wiecznego" spinnera.
  const handlePropertySelect = (value: string) => {
    if (value) navigate(`/properties/${value}`);
    onPropertyChange(value);
  };

  const handleWorkerSelect = (value: string) => {
    if (value) navigate(`/workers/${value}`);
    onWorkerChange(value);
  };

  return (
    <div
      className={cn(
        "flex flex-col gap-4 sm:flex-row sm:items-end rounded-lg border border-border bg-card p-4",
        className
      )}
    >
      <div className="grid flex-1 gap-2">
        <label className="text-sm font-medium text-muted-foreground">
          Przejdź do nieruchomości
        </label>
        <SearchableSelect
          options={propertyOptions}
          value={propertyValue}
          onValueChange={handlePropertySelect}
          placeholder="Wybierz nieruchomość..."
          searchPlaceholder="Szukaj adresu..."
          emptyText="Brak nieruchomości"
        />
      </div>
      <div className="grid flex-1 gap-2">
        <label className="text-sm font-medium text-muted-foreground">
          Przejdź do pracownika
        </label>
        <SearchableSelect
          options={workerOptions}
          value={workerValue}
          onValueChange={handleWorkerSelect}
          placeholder="Wybierz pracownika..."
          searchPlaceholder="Szukaj..."
          emptyText="Brak pracowników"
        />
      </div>
    </div>
  );
}
